export function getRentals(state) {
    return state.rentals;
}
